// extracted by mini-css-extract-plugin
export default {"link":"jD-z","disabled":"kD-z"};